import Image from 'next/legacy/image';
import styles from './styles.module.css';
import { ICONS, Icon } from '@/modules/ui-elements/Icon';
import { useSelector } from 'react-redux';

export default function ProjectList(props) {
    const isAiTaskDisable = props?.item?.aiTaskDisable;
    return(
        <div className={styles.singleProject} style={{ opacity: isAiTaskDisable ? 0.4 : 1, cursor: isAiTaskDisable ? 'not-allowed' : 'pointer' }} onClick={() => props.onProjectSelect(props?.item)}>
            <div className={styles.projectDetails}>
                <div className={styles.projectImage}>
                    <Image src={props?.item?.banner_image || '/icons/settings/shopify.svg'} height={20} width={20} />
                </div>
                <div className={styles.projectName}>{props?.item?.name}</div>
            </div>
            <Icon src={ICONS.chevronRightDark} height={16} width={16} />
        </div>
    )
}